module.exports = __webpack_public_path__ + "img/duck-head.7d93a480.jpg";